exports = module.exports = require("../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._15mULzMsNkAlQ37AQxDaeO{text-decoration:underline;cursor:text}.w9ecHQbVUox7ABDzfLvBr{cursor:pointer}", ""]);
// Exports
exports.locals = {
	"n-editor-link": "_15mULzMsNkAlQ37AQxDaeO",
	"n-activeLink": "w9ecHQbVUox7ABDzfLvBr"
};